/* AirFlow Pro · PDP estilo HiStrips (12-oct-2026): galería, packs (variantes), carrito, barra fija y despacho en vivo
   v4 (13-oct): 3x2 mezclando colores. La tarjeta del 3x2 abre "Arma tu 3x2": 3 casilleros + 5 colores.
   Tocar un color lo suma; con 3 elegidos, el nuevo reemplaza al más antiguo. Tocar un casillero lo quita.
   Al agregar se mandan las 3 unidades del pack de 1 mes de cada color; el descuento 3x2 automático de
   Shopify (compra 2, lleva 1 gratis, solo variantes de 1 mes) deja gratis la de menor precio. */
(function () {
  var nf = new Intl.NumberFormat('es-CL');
  var plata = function (n) { return '$' + nf.format(n); };
  /* Feriados de Chile: mantener esta lista al día (el despacho del mismo día es en días hábiles). */
  var FERIADOS = ['2026-10-12', '2026-10-31', '2026-11-01', '2026-12-08', '2026-12-25', '2027-01-01'];
  var dl = function (o) { window.dataLayer = window.dataLayer || []; window.dataLayer.push(o); };

  function iniciar(root) {
    if (root.dataset.init) return;
    root.dataset.init = '1';

    var slides = root.querySelector('[data-hs-slides]');
    var thumbs = [].slice.call(root.querySelectorAll('.hs-gal__thumb'));
    var dots = [].slice.call(root.querySelectorAll('.hs-gal__dots i'));
    function marcar(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = Number(t.dataset.i);
        if (slides) slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' });
        marcar(i);
      });
    });
    if (slides) {
      var raf;
      slides.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { marcar(Math.round(slides.scrollLeft / slides.clientWidth)); });
      }, { passive: true });
    }

    var packs = [].slice.call(root.querySelectorAll('.hs-pack'));
    var atc = root.querySelector('[data-hs-atc]');
    var q = function (s) { return root.querySelector(s); };
    var now = q('[data-now]'), was = q('[data-was]'), save = q('[data-save]'), meta = q('[data-meta]');
    var atcPrice = q('[data-atc-price]'), sp = q('[data-sticky-price]'), sw = q('[data-sticky-was]');

    function pintar(precio, tachado, metaTxt, atcTxt) {
      var ahorro = tachado > precio ? tachado - precio : 0;
      if (now) now.textContent = plata(precio);
      if (was) { was.textContent = plata(tachado); was.hidden = !ahorro; }
      if (save) { save.textContent = 'AHORRAS ' + plata(ahorro); save.hidden = !ahorro; }
      if (meta) meta.textContent = metaTxt;
      if (atcPrice) atcPrice.textContent = atcTxt || ('· ' + plata(precio));
      if (sp) sp.textContent = plata(precio);
      if (sw) sw.textContent = ahorro ? plata(tachado) : '';
    }

    /* ── v4 · Arma tu 3x2 ─────────────────────────────────────────────── */
    var mix = q('[data-hs-mix]');
    var mixSlots = mix ? mix.querySelector('[data-mix-slots]') : null;
    var mixNote = mix ? mix.querySelector('[data-mix-note]') : null;
    var mixOpts = mix ? [].slice.call(mix.querySelectorAll('[data-mix-opt]')) : [];
    var mixCard = packs.filter(function (p) { return p.dataset.mix; })[0];
    var info = {};
    mixOpts.forEach(function (o) { info[o.dataset.vid] = { precio: Number(o.dataset.price), nombre: o.dataset.name, img: o.dataset.img }; });
    var slots = [];
    if (mix && info[mix.dataset.default]) slots = [mix.dataset.default, mix.dataset.default, mix.dataset.default];
    var mixOn = false, nuevo = -1;

    function cuenta() {
      var total = 0, min = Infinity, distintos = {};
      slots.forEach(function (v) { var p = info[v].precio; total += p; if (p < min) min = p; distintos[p] = 1; });
      var gratis = slots.length === 3 ? min : 0;
      return { total: total, gratis: gratis, paga: total - gratis, mezclaPrecios: Object.keys(distintos).length > 1 };
    }

    function renderMix() {
      if (!mix) return;
      var c = cuenta(), falta = 3 - slots.length;
      if (mixSlots) {
        var h = '';
        for (var i = 0; i < 3; i++) {
          var v = slots[i];
          if (v) {
            h += '<button type="button" class="hs-mix__slot is-full' + (i === nuevo ? ' is-new' : '') + '" data-i="' + i + '" aria-label="Quitar ' + info[v].nombre + '">' +
              '<img src="' + info[v].img + '" alt="" width="64" height="24"><span>' + info[v].nombre + '</span><i aria-hidden="true">×</i></button>';
          } else {
            h += '<span class="hs-mix__slot"><em>+</em><span>Elige</span></span>';
          }
        }
        mixSlots.innerHTML = h;
        nuevo = -1;
      }
      mixOpts.forEach(function (o) {
        var n = slots.filter(function (v) { return v === o.dataset.vid; }).length;
        var b = o.querySelector('[data-n]');
        if (b) { b.textContent = n; b.hidden = !n; }
        o.classList.toggle('is-on', n > 0);
        o.setAttribute('aria-pressed', n > 0 ? 'true' : 'false');
      });
      if (mixNote) {
        mixNote.innerHTML = falta
          ? 'Elige <b>' + falta + ' más</b> para completar tu 3x2.'
          : '🎁 Pagas 2 y te llevas 3: ahorras <b>' + plata(c.gratis) + '</b>' + (c.mezclaPrecios ? ' (va gratis el de menor precio).' : '.');
      }
      if (atc) atc.classList.toggle('is-wait', mixOn && !!falta);
      if (mixCard && !falta) {
        var cb = mixCard.querySelector('[data-card-price]'), cs = mixCard.querySelector('[data-card-was]'), ca = mixCard.querySelector('[data-card-save]');
        if (cb) cb.textContent = plata(c.paga);
        if (cs) cs.textContent = plata(c.total);
        if (ca) ca.textContent = 'Ahorras ' + plata(c.gratis);
      }
      if (!mixOn) return;
      if (falta) pintar(c.total, 0, 'Elige ' + falta + ' más para completar el 3x2', '· elige ' + falta + ' más');
      else pintar(c.paga, c.total, '90 tiras · ' + plata(Math.round(c.paga / 90)) + ' por tira');
    }

    mixOpts.forEach(function (o) {
      o.addEventListener('click', function () {
        if (slots.length >= 3) slots.shift();
        slots.push(o.dataset.vid);
        nuevo = slots.length - 1;
        renderMix();
        dl({ event: 'mix_3x2_color', color: o.dataset.name, total: slots.length });
      });
    });
    if (mixSlots) {
      mixSlots.addEventListener('click', function (e) {
        var s = e.target.closest('[data-i]');
        if (!s) return;
        slots.splice(Number(s.dataset.i), 1);
        renderMix();
      });
    }

    function elegir(b, porUsuario) {
      packs.forEach(function (p) { var on = p === b; p.classList.toggle('is-on', on); p.setAttribute('aria-checked', on ? 'true' : 'false'); });
      mixOn = !!(b.dataset.mix && mix);
      if (mix) mix.hidden = !mixOn;
      if (atc) atc.dataset.variantId = b.dataset.id;
      if (mixOn) {
        renderMix();
      } else {
        if (atc) atc.classList.remove('is-wait');
        pintar(Number(b.dataset.price), Number(b.dataset.compare), b.dataset.tiras + ' tiras · ' + plata(Number(b.dataset.per)) + ' por tira');
      }
      if (porUsuario) {
        try { var u = new URL(location.href); u.searchParams.set('variant', b.dataset.id); history.replaceState(history.state, '', u); } catch (e) {}
        dl({ event: 'pack_tier_select', tier: Number(b.dataset.packs), qty: 1, variant_id: b.dataset.id, mix: mixOn });
      }
    }
    packs.forEach(function (b) { b.addEventListener('click', function () { if (!b.disabled) elegir(b, true); }); });
    var inicial = packs.filter(function (p) { return p.classList.contains('is-on'); })[0] || packs[0];
    if (inicial) elegir(inicial, false);

    function avisarMix() {
      if (!mix) return;
      mix.scrollIntoView({ behavior: 'smooth', block: 'center' });
      mix.classList.remove('is-warn');
      void mix.offsetWidth;
      mix.classList.add('is-warn');
    }

    function agregar(boton) {
      var items, valor, nombre;
      if (mixOn) {
        if (slots.length < 3) { avisarMix(); return; }
        var cnt = {};
        slots.forEach(function (v) { cnt[v] = (cnt[v] || 0) + 1; });
        items = Object.keys(cnt).map(function (v) { return { id: Number(v), quantity: cnt[v] }; });
        valor = cuenta().paga;
        nombre = '3x2 mezcla';
      } else {
        var id = Number(atc && atc.dataset.variantId);
        if (!id) return;
        items = [{ id: id, quantity: 1 }];
        var on = root.querySelector('.hs-pack.is-on');
        valor = on ? Number(on.dataset.price) : undefined;
        nombre = on ? (Number(on.dataset.packs) === 1 ? '1 mes' : on.dataset.packs + ' meses') : '';
      }
      var b = boton || atc, html = b.innerHTML;
      b.disabled = true; b.textContent = 'Agregando…';
      fetch(root.dataset.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        if (window.afpGift && window.afpGift.activo()) return window.afpGift.asegurar().catch(function () {});
      }).then(function () {
        dl({ ecommerce: null });
        dl({ event: 'add_to_cart', ecommerce: { currency: 'CLP', value: valor, items: items.map(function (it) {
          var inf = info[String(it.id)];
          return { item_id: String(it.id), item_name: inf ? inf.nombre : (root.dataset.title || document.title), item_variant: nombre, price: inf ? inf.precio : valor, quantity: it.quantity };
        }) } });
        if (root.dataset.afterAdd === 'checkout') { location.href = '/checkout'; return; }
        var movil = window.matchMedia('(max-width: 749px)').matches;
        var drawer = movil ? null : document.querySelector('dialog.cart-drawer__dialog');
        if (drawer) {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'afp-buybox' } } }));
          var comp = document.querySelector('cart-drawer-component');
          setTimeout(function () { if (comp && typeof comp.open === 'function') comp.open(); else drawer.showModal(); }, 250);
          b.disabled = false; b.innerHTML = html;
        } else {
          location.href = root.dataset.cart || '/cart';
        }
      }).catch(function () {
        b.textContent = 'Reintentar'; b.disabled = false;
        setTimeout(function () { b.innerHTML = html; }, 1600);
      });
    }
    if (atc) atc.addEventListener('click', function () { agregar(atc); });

    var sticky = q('[data-hs-sticky]'), sbtn = q('[data-hs-sticky-btn]');
    if (sbtn) sbtn.addEventListener('click', function () { agregar(sbtn); });
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0], mostrar = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', mostrar);
        sticky.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
        if (sbtn) sbtn.tabIndex = mostrar ? 0 : -1;
      }).observe(atc);
    }

    /* v2: caja "Pide antes de las 12:00 y te llega HOY" — urgencia real: cuenta regresiva solo en día hábil antes de las 12:00 (hora Chile). */
    var live = q('[data-hs-live]');
    function despacho() {
      if (!live) return;
      try {
        var p = {};
        new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
          .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
        var hoy = new Date(Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day)));
        var iso = function (d) { return d.toISOString().slice(0, 10); };
        var habil = function (d) { var w = d.getUTCDay(); return w > 0 && w < 6 && FERIADOS.indexOf(iso(d)) === -1; };
        var hora = Number(p.hour) % 24, min = Number(p.minute), t, sub;
        var tEl = live.querySelector('[data-today-t]'), sEl = live.querySelector('[data-today-s]');
        if (habil(hoy) && hora < 12) {
          var faltan = 720 - (hora * 60 + min), hh = Math.floor(faltan / 60), mm = faltan % 60;
          t = 'Pide antes de las 12:00 y te llega <mark>HOY</mark>';
          sub = 'Región Metropolitana · te quedan <b>' + (hh ? hh + ' h ' : '') + mm + ' min</b>';
        } else {
          var d = new Date(hoy.getTime()), dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
          do { d.setUTCDate(d.getUTCDate() + 1); } while (!habil(d));
          var manana = (d - hoy) === 86400000;
          t = 'Pide ahora y te llega <mark>' + (manana ? 'MAÑANA' : 'EL ' + dias[d.getUTCDay()].toUpperCase()) + '</mark>';
          sub = 'Región Metropolitana · pidiendo antes de las 12:00 en día hábil, te llega el mismo día';
        }
        if (tEl) tEl.innerHTML = t;
        if (sEl) sEl.innerHTML = sub;
      } catch (e) {}
    }
    despacho();
    setInterval(despacho, 30000);
  }

  function todo() { [].forEach.call(document.querySelectorAll('[data-hs]'), iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo();
})();
